import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ServiceMetaData } from 'src/app/core/models/shared/ServiceMetaData';

@Injectable()
export class ServiceMetadataLoadedStateManager {
  private readonly metadataSubject =
    new BehaviorSubject<ServiceMetaData | null>(null);

  // Read-only observable for subscribers
  public readonly metadata$: Observable<ServiceMetaData | null> =
    this.metadataSubject.asObservable();

  // Get current state synchronously
  public get metadata(): ServiceMetaData | null {
    return this.metadataSubject.value;
  }

  // Publish/update state
  public setMetadata(metadata: ServiceMetaData): void {
    this.metadataSubject.next(metadata);
  }

  // Clear state
  public clear(): void {
    this.metadataSubject.next(null);
  }
}
